// Source do ImageBoss que aponta para o bucket de imagens (hoje o sischef-images na Linode, que é privado).
const IMAGEBOSS_SOURCE = process.env.REACT_APP_IMAGEBOSS_SOURCE || "sischef-images";

export const DEFAULT_IMAGEBOSS_URL = `https://img.imageboss.me/${IMAGEBOSS_SOURCE}`;
